module.exports = __webpack_public_path__ + "img/tretonian.811d0fc.png";